/* eslint-disable no-console */

import { register } from 'register-service-worker'
import router from './router'
import alertify from 'alertifyjs'


const notifyUserAboutUpdate = worker => {

	alertify.alert("App Updated", "An update to the app has been released!", () => {
		worker.postMessage({ action: 'skipWaiting' })
	}).setting({
		'label'    : 'Update Now',
		'closable' : false,
		'movable'  : false
	})
}

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      console.info(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered (registration) {
      console.info('Service worker has been registered.')
    },
    cached () {
      console.info('Content has been cached for offline use.')
    },
    updatefound (registration) {
      console.info('New content is downlaoding')
    },
    updated (registration) {
      console.info('New content is available; please refresh.')
      
      if (router.currentRoute.value.name === 'wip') {
        window.location.reload()
      } else {
        notifyUserAboutUpdate(registration.waiting)
      }
    },
    offline () {
      console.info('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })

  var refreshing;
  navigator.serviceWorker.addEventListener("controllerchange", function() {
    if (refreshing) {
      return
    }

    window.location.reload()
    refreshing = true
  })
}

